import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Alert, Button, Checkbox, Divider, /*Input,*/ Modal, Radio} from 'antd'
import queryString from 'qs'
import {exportOrderByQueryV2, exportCsvOrderByQuery, exportCsvWarningOrderByQuery} from "../../../../../services/api/3dApi"
import downloadFileFromData from '../../../../../helpers/downloadFileFromData'
import getErrorMessage from '../../../../../helpers/getErrorMessage'

class ExportOrders extends Component {
    state = {
        visible: false,
        loading: false,
        message: {},
        link: '',
        details: false,
        confirm: false,
    }

    _showModal = () => {
        this.setState({visible: true})
    }

    _hideModal = () => {
        this.setState({
            visible: false,
            message: {},
            link: '',
            details: false,
            confirm: false,
            loading: false,
        })
    }

    _handleOk = async () => {
        try {
            this.setState({
                loading: true,
                message: {},
            })

            const {filters} = this.props
            const {link, details} = this.state
            const payload = {
                query: filters,
                link,
                details,
            }

            const {data: response} = await exportOrderByQueryV2(payload)
            const {success, error} = response

            if (!success) throw new Error(error)

            this._hideModal()
        } catch (e) {
            this.setState({
                loading: false,
                message: {
                    type: 'error',
                    content: e.message,
                },
            })
        }
    }

    _handleOkCSV = async () => {
        try {
            this.setState({
                loading: true,
                message: {},
            })

            const {filters} = this.props
            const {details} = this.state
            const payload = {
                ...filters,
                details,
            }
            if (typeof details !== 'boolean') {
                delete payload.details
            }
            const { data } = (details === 'WarningOrder' ? await exportCsvWarningOrderByQuery(payload) : await exportCsvOrderByQuery(payload))

            if (data) {
                downloadFileFromData(data, { filename: `export-${details === 'WarningOrder' ? 'warning-orders' : 'orders'}-tool3d.csv` })
            }

            this._hideModal()
        } catch (e) {
            const errorMessage = getErrorMessage(e)

            this.setState({
                loading: false,
                message: {
                    type: 'error',
                    content: errorMessage,
                },
            })
        }
    }

    _handleChange = e => {
        const {value, name} = e.target

        this.setState({
            [name]: value,
        })
    }

    _handleConfirm = e => {
        this.setState({
            confirm: e.target.checked,
        })
    }

    render() {
        const {visible, loading, message, details, confirm} = this.state
        const {total, loading: loadingFilter} = this.props

        return (
            <div className='ExportOrders'>
                <Button disabled={loadingFilter} icon='export' onClick={this._showModal}>Xuất đơn</Button>

                <Modal visible={visible} onCancel={this._hideModal} onOk={this._handleOkCSV} okText='Submit'
                       okButtonProps={{disabled: !confirm}}
                       confirmLoading={loading}>

                    <h6>Kiểu xuất đơn</h6>
                    <Radio.Group value={details} name='details' onChange={this._handleChange}>
                        <Radio value={false}>Mặc định</Radio>
                        <Radio value={true}>Chi tiết</Radio>
                        <Radio value={'WarningOrder'}>Cảnh báo</Radio>
                    </Radio.Group>

                    <Divider/>

                    <Checkbox onChange={this._handleConfirm} checked={confirm}>
                        Xác nhận xuất <strong>{total}</strong> đơn
                    </Checkbox>

                    {
                        message.hasOwnProperty('type') &&
                        <Alert message={message.content} type={message.type} className='mt-3'/>
                    }
                </Modal>
            </div>
        )
    }
}

ExportOrders.defaultProps = {
    loading: false
}

ExportOrders.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    total: PropTypes.number.isRequired,
}

export default ExportOrders
